import { colors, devices } from '../../config/theme'

const style = {}

style.base = {
  height: '100%',
  '& .profileVisit': {
    color: '#808FA9',
    marginBottom: '4px'
  },
  '& .profileDate': {
    fontWeight: '500'
  },
  '& .profileArea': {
    marginBottom: '20px !important',

    '&> div': {
      '& h1': {
        fontWeight: '500'
      },
      width: 'auto'
    }
  },

  '@media only screen and (max-width: 1295px)': {
    '& .profileContainer': {
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'column'
    }
  },
  '@media only screen and (min-width: 1295px)': {
    '& .profileContainer': {
      display: 'flex',
      justifyContent: 'space-between'
    }
  }
}

style.base[devices.desktop] = {
  '& img': {
    marginBottom: '0 !important'
  },
  '& .profileArea': {
    flexGrow: '2',
    '&> div': {
      '& h1': {
        marginBottom: '10px',
        fontSize: '30px'
      },
      width: 'auto'
    }
  }
}

style.base[devices.mobile] = {
  '& .date-container': {
    paddingBottom: '30px',
    marginBottom: '0 !important',
    boxShadow: `0px 3px 3px ${colors.lighterGray}`,
    position: 'fixed',
    width: '100%',
    zIndex: '1',
    backgroundColor: colors.white
  },
  '& .details-container': {
    top: '139px',
    position: 'relative'
  },
  '& .profileDate': {
    color: colors.blue,
    fontWeight: '500'
  },
  '& .profileArea': {
    flexDirection: 'column !important',
    textAlign: 'center !important',
    width: '100%',
    backgroundColor: '#F4F4F4',
    paddingTop: '34px',
    '& h1': {
      fontSize: '26px',
      marginBottom: '30px !important'
    },
    '& img': {
      width: '125px !important',
      height: '125px !important',
      margin: '0 auto 15px auto !important'
    }
  }
}

export default style
